import { HttpClient, HttpResponse } from '@angular/common/http';
import { BlockUIService } from 'ng-block-ui';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';

export class ajaxCallReturnValue<T> {
  success: boolean;
  results: T;
  message: string;
}

export class DataTablesResponse<T> {
  recordsTotal: number;
  recordsFiltered: number;
  data: T[];
}

@Injectable()
export class ajaxCall {
  constructor(private http: HttpClient,
    private router: Router,
    private notifier: NotifierService,
    private blockUI: BlockUIService) {
  }

  public MakeCall<T>(url, object?, doLoading?): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      doLoading = ((typeof doLoading !== 'undefined') ? doLoading : true);

      if (doLoading) {
        this.blockUI.start('ajaxCall');
      }

      url = '/data' + url;

      this.http.post<ajaxCallReturnValue<T>>(url, object).subscribe(response => {
        if (response.success) {
          resolve(response.results);
        } else {
          if (response.message) {
            this.notifier.notify('error', response.message);
          }
          reject(response);
        }
        if (doLoading) {
          this.blockUI.stop('ajaxCall');
        }
      }, response => {
        if (response.status === 403 || response.status === 401) {
          //this.router.navigateByUrl('/login');
          window.location.href = '/admin/login';
          return;
        }
        reject();

        if (doLoading) {
          this.blockUI.stop('ajaxCall');
        }
      });
    });
  }
}
